import { ISelectProp } from 'interfaces/SelectProp';

export const AmbulanceOptions: ISelectProp[] = [
  {
    label: 'Advanced Life Support Ambulance',
    value: 'ALSA',
  },
  {
    label: 'Basic Life Support Ambulance',
    value: 'BLSA',
  },
  {
    label: 'Mass Casualty / Mass Transport Unit',
    value: 'MCMTU',
  },
  {
    label: 'Quick Response Vehicle (ALS)',
    value: 'QRV',
  },
  {
    label: 'Special Purpose Ambulance',
    value: 'SPA',
  },
  {
    label: 'Ventilator Equipped Ambulance',
    value: 'VEA',
  },
];

export const JobPositions: ISelectProp[] = [
  {
    label: 'AEMT',
    value: 'AEMT',
  },
  {
    label: 'CP/MIH',
    value: 'CP/MIH',
  },
  {
    label: 'Critical Care',
    value: 'CRITICAL',
  },
  {
    label: 'Driver',
    value: 'DRIVER',
  },
  {
    label: 'EMT',
    value: 'EMT',
  },
  {
    label: 'Paramedic',
    value: 'PARAMEDIC',
  },
];

export const ServiceTypes: ISelectProp[] = [
  {
    label: 'Air Medical',
    value: 'air',
  },
  {
    label: '911 Response (Scene) With Transport Capability',
    value: '911_transport',
  },
  {
    label: '911 Response (Scene) Without Transport Capability',
    value: '911_notransport',
  },
  {
    label: 'Medical Transport (Convalescent)',
    value: 'medical',
  },
  {
    label: 'Specialty Care Transport',
    value: 'specialty',
  },
];
